<div class="ui basic segment" [class.loading]="isLoading">
    <app-steps
        #steps
        [steps]="[personalStep, jobStep, payrollStep, reviewStep]"
        (onPrimary)="onSave()"
        (onNext)="focusInput()"
        (onPrevious)="focusInput()"
    >
        <app-step
            step="forms.add-terminated.personal.stepTitle"
            title="forms.add-terminated.personal.title"
            #personalStep
            [stepForm]="personalForm"
        >
            <app-form-employees-create-terminated-personal
                #personalForm
                [account]="account"
                [employee]="employee"
                [address]="address"
            >
            </app-form-employees-create-terminated-personal>
        </app-step>

        <app-step
            step="forms.add-terminated.job.stepTitle"
            title="forms.add-terminated.job.title"
            #jobStep
            [stepForm]="jobForm"
        >
            <app-form-employees-create-terminated-job
                #jobForm
                [offices]="offices"
                [employee]="employee"
                [(terminatedOn)]="terminatedOn"
            >
            </app-form-employees-create-terminated-job>
        </app-step>

        <app-step
            step="forms.add-terminated.payroll.stepTitle"
            title="forms.add-terminated.payroll.title"
            #payrollStep
            [stepForm]="payrollForm"
        >
            <app-form-employees-create-terminated-payroll
                #payrollForm
                [employee]="employee"
                [salary]="salary"
                [canDoPayroll]="canDoPayroll"
            >
            </app-form-employees-create-terminated-payroll>
        </app-step>

        <app-step
            step="forms.add-terminated.review.stepTitle"
            title="forms.add-terminated.review.title"
            #reviewStep
            [stepForm]="reviewForm"
        >
            <app-forms-employees-create-terminated-review
                #reviewForm
                [canDoPayroll]="canDoPayroll"
                [employee]="employee"
                [account]="account"
                [address]="address"
                [salary]="salary"
                [terminatedOn]="terminatedOn"
            >
            </app-forms-employees-create-terminated-review>
        </app-step>
    </app-steps>
</div>
